import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>
          Mida ette võtta, kui laenu tagasimaksmine hakkab üle jõu käima või
          oled jätnud arved tähtajaks tasumata?
        </Summary>
        <Details>
          <Text>
            Kõige olulisem on kohe probleemiga tegeleda ja laenuandjaga või
            ettevõttega, kellele oled võlgu jäänud, ühendust võtta. Mida
            kiiremini reageerid, seda suurem on võimalus saavutada mõlemale
            poolele sobiv kokkulepe. Samuti arvesta, et sulle on kasulik, kui
            sinu makseajalugu säilib korrektsena ja sinu kohta pole märget
            maksehäireregistris.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Miks on minu võlg PlusPlus Capitalis?</Summary>
        <Details>
          <Text>
            PlusPlus Capital ostab regulaarselt maksmata jäetud arvetest
            koosnevaid võlaportfelle pankadelt, mobiilifirmadelt ja teistelt
            suure kliendibaasiga ettevõtetelt. Ettevõtted ei soovi enamasti ise
            tegeleda klientidega, kes ei täida oma kohustusi tähtaegselt ja need
            nõuded müüakse võlgade sissenõudmisega tegelevatele ettevõtetele.
            Kui teie täitmata kohustused on jõudnud PlusPlus Capitali, siis seda
            just eelkirjeldatud viisil ja põhjustel. PlusPlus Capital on nõude
            uus õiguslik omanik ja seega ka edasine suhtluspartner võlgnevuse
            kustutamisel.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Kuidas toimida?</Summary>
        <Details>
          <Text>
            Olles aja jooksul kokku puutunud kümnete tuhandete sarnaste
            juhtumitega, mõistame, miks ei ole alati võimalik oma rahalisi
            kohustusi täita. Sel põhjusel pakume abi koostamaks mõistlik ja
            jõukohane võlgnevuste kustutamise makseplaan, arvestades
            konkreetseid sissetulekuid ja muid asjaolusid. Meie professionaalsed
            töötajad on orienteeritud asjade kiirele ja efektiivsele
            lahendamisele, seega palun helistage PlusPlus Capitali poolt teile
            saadetud kirjas toodud numbrile või pöörduge meie poole e-maili
            vahendusel, viidates kirjas toodud viitenumbrile. Mida kiiremini
            leppida kokku võlasuhte lahendamises, seda odavam ja kõigile
            osapooltele lihtsam see on.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Kellega peaksin oma võla osas suhtlema?</Summary>
        <Details>
          <Text>
            Juhul, kui PlusPlus Capital on teiega kontakteerunud, tähendab see
            seda, et teie esialgne võlausaldaja ei ole määratud aja jooksul
            saanud teievahelisele võlasuhtele positiivset lahendust või
            kokkulepet ja ta on nõude müünud. Seega on nõude omanik ja selle
            lahendamise osas suhtluspartner PlusPlus Capital ning esialgse
            võlausaldajaga ei ole enam põhjust selles küsimuses suhelda. Juhul,
            kui pöördute oma esialgse võlausaldaja poole, suunatakse teid tagasi
            PlusPlus Capitali juurde.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Miks mulle varem võlast ei teatatud?</Summary>
        <Details>
          <Text>
            Kui olete allkirjastanud pangas laenulepingu või sõlminud
            teenuslepingu näiteks mobiilioperaatoriga, siis tavaliselt selline
            dokument võimaldab müüa lepingust tulenevad võlgnevused
            ettevõtetele, nagu PlusPlus Capital koos kõigi lepingust tulenevate
            õigustega. Pangad, mobiilioperaatorid ja teised teenusettevõtted
            üritavad teatud perioodi vältel saada ise võlgnevused kätte ja
            kontakteeruvad selles asjas oma klientidega enamasti korduvalt.
            Samuti on tavaks teavitada kliente nõuete müümisest kolmandatele
            isikutele. Ka PlusPlus Capital teavitab koheselt kirjaga klienti
            nõude ostmisest. Need kirjad saadetakse kliendi viimati teadaolevale
            aadressile ja kui näiteks kolimise käigus on jäänud aadress
            kliendiandmebaasis uuendamata, võib juhtuda, et teave võlgnevusest
            ja selle võõrandamisest ei jõua alati kohale.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Mis juhtub minu krediidiinfoga?</Summary>
        <Details>
          <Text>
            Ettevõtete krediidihaldusprotseduurid näevad ette, et teatud
            vanusest ja summast alates teavitatakse kliendi võlgnevusest
            Krediidiinfo maksehäireregistrit. Selline teave on avalikult
            kättesaadav ja võib saada takistuseks tulevikus soovitavatele
            laenudele, liisingutele, järelmaksudele ja teistele
            krediiditoodetele, aga ka uuele töökohale asumisel või üürilepingu
            sõlmimisel.
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
